export default __webpack_public_path__ + "static/media/fxMute.a7e4fc83.mp3";